import React, { useEffect, useState } from "react";
import { Select, Form } from "antd";
import { store } from '@root/store';

export interface HospitalProps {
    id: number,
    name: string
}

export interface HospitalSelectProps {
    label?: string | boolean,
    name?: string,
    styles?: React.CSSProperties,
    showAll?: boolean,
    placeholder?: string,
    rules?: any,
    onSelect?: (value: number) => void;
}

const { Option } = Select;
const HospitalSelect: React.FC<HospitalSelectProps> = (props) => {
    const { label, name, styles, showAll, placeholder, rules, onSelect } = props;
    const [hospitalList, setList] = useState<HospitalProps[]>([]);

    useEffect(() => {
        setList(store.getState().directionaries.instituteList || []);
    }, [])

    const onSelectHandle = (value: number) => {
        onSelect && onSelect(value)
    }

    return (
        <Form.Item
            label={label}
            name={name}
            style={{ ...styles }}
            rules={rules}
        >
            <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                filterSort={(optionA, optionB) =>
                    (optionA!.children as unknown as string)
                        .toLowerCase()
                        .localeCompare((optionB!.children as unknown as string).toLowerCase())
                }
            >
                {showAll && <Option value="all">全部</Option>}
                {
                    hospitalList.map((item, index) => {
                        return <Option value={item.id} key={index}>{item.name}</Option>
                    })
                }
            </Select>
        </Form.Item>
    )
}

HospitalSelect.defaultProps = {
    label: '学科',
    name: 'hospital',
    showAll: false,
    placeholder: '请选择所在学科'
}

export default HospitalSelect;